import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { OOHRow } from '../../../../../../../../../../api/services/mediaPlanning/offline/oohBudget';
import { formatNumberWithSpaces } from '../../../../../../../common/BudgetTable/utils/formatNumberWithSpaces';
import { Budget } from '../../../../../../../../../../store/planStore';

const COLUMN_ALIGN_LEFT = 'left' as const;
const COLUMN_ALIGN_CENTER = 'center' as const;
const COLUMN_ALIGN_RIGHT = 'right' as const;

export default (currency: string) => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        key: 'format' as keyof OOHRow,
        align: COLUMN_ALIGN_LEFT,
        label: t('mediaPlanning.ooh.table.columns.type'),
      },
      {
        key: 'variant' as keyof OOHRow,
        align: COLUMN_ALIGN_LEFT,
        label: t('mediaPlanning.ooh.table.columns.option'),
        width: '30%',
      },
      {
        key: '' as keyof OOHRow,
        align: COLUMN_ALIGN_RIGHT,
        label: '',
        width: '10%',
        renderer: () => <Typography />,
      },
      {
        key: '' as keyof OOHRow,
        align: COLUMN_ALIGN_CENTER,
        label: '',
        width: '10%',
        renderer: () => <Typography />,
      },
      {
        key: '' as keyof OOHRow,
        align: COLUMN_ALIGN_CENTER,
        label: '',
        width: '10%',
        renderer: () => <Typography />,
      },
      {
        key: 'budget' as keyof OOHRow,
        label: `${t('mediaPlanning.ooh.table.columns.budget')} (${currency})`,
        dividerColumn: true,
        align: COLUMN_ALIGN_RIGHT,
        padding: '0 24px',
        renderer: (data: Budget) => {
          return (
            <Typography fontSize="0.875rem" align="right">
              {formatNumberWithSpaces(data.value.toFixed(0))} {data.currency}
            </Typography>
          );
        },
      },
    ],
    [t]
  );
};
